/******************************
* GENERATED FILE, DO NOT EDIT *
*******************************/
export type ColorName = "algae50"|"algae100"|"algae200"|"algae300"|"algae400"|"algae500"|"algae600"|"algae700"|"algae800"|"algae900"|"algae950"|"algaeDefault"|"blue50"|"blue100"|"blue200"|"blue300"|"blue400"|"blue500"|"blue600"|"blue700"|"blue800"|"blue900"|"blue950"|"blueDefault"|"foam50"|"foam100"|"foam200"|"foam300"|"foam400"|"foam500"|"foam600"|"foam700"|"foam800"|"foam900"|"foam950"|"foamDefault"|"greyDefault"|"freshWater50"|"freshWater100"|"freshWater200"|"freshWater300"|"freshWater400"|"freshWater500"|"freshWater600"|"freshWater700"|"freshWater800"|"freshWater900"|"freshWater950"|"freshWaterDefault"|"green50"|"green100"|"green200"|"green300"|"green400"|"green500"|"green600"|"green700"|"green800"|"green900"|"green950"|"greenDefault"|"lagoon50"|"lagoon100"|"lagoon200"|"lagoon300"|"lagoon400"|"lagoon500"|"lagoon600"|"lagoon700"|"lagoon800"|"lagoon900"|"lagoon950"|"lagoonDefault"|"ocean50"|"ocean100"|"ocean200"|"ocean300"|"ocean400"|"ocean500"|"ocean600"|"ocean700"|"ocean800"|"ocean900"|"ocean950"|"oceanDefault"|"orange50"|"orange100"|"orange200"|"orange300"|"orange400"|"orange500"|"orange600"|"orange700"|"orange800"|"orange900"|"orange950"|"orangeDefault"|"red50"|"red100"|"red200"|"red300"|"red400"|"red500"|"red600"|"red700"|"red800"|"red900"|"red950"|"redDefault"|"accounting50"|"accounting100"|"accounting200"|"accounting300"|"accounting400"|"accounting500"|"accounting600"|"accounting700"|"accounting800"|"accounting900"|"accounting950"|"accountingDefault"|"analysis50"|"analysis100"|"analysis200"|"analysis300"|"analysis400"|"analysis500"|"analysis600"|"analysis700"|"analysis800"|"analysis900"|"analysis950"|"analysisDefault"|"cashRegisterSheet50"|"cashRegisterSheet100"|"cashRegisterSheet200"|"cashRegisterSheet300"|"cashRegisterSheet400"|"cashRegisterSheet500"|"cashRegisterSheet600"|"cashRegisterSheet700"|"cashRegisterSheet800"|"cashRegisterSheet900"|"cashRegisterSheet950"|"cashRegisterSheetDefault"|"documents50"|"documents100"|"documents200"|"documents300"|"documents400"|"documents500"|"documents600"|"documents700"|"documents800"|"documents900"|"documents950"|"documentsDefault"|"haccp50"|"haccp100"|"haccp200"|"haccp300"|"haccp400"|"haccp500"|"haccp600"|"haccp700"|"haccp800"|"haccp900"|"haccp950"|"haccpDefault"|"hr50"|"hr100"|"hr200"|"hr300"|"hr400"|"hr500"|"hr600"|"hr700"|"hr800"|"hr900"|"hr950"|"hrDefault"|"importExport50"|"importExport100"|"importExport200"|"importExport300"|"importExport400"|"importExport500"|"importExport600"|"importExport700"|"importExport800"|"importExport900"|"importExport950"|"importExportDefault"|"materialManagement50"|"materialManagement100"|"materialManagement200"|"materialManagement300"|"materialManagement400"|"materialManagement500"|"materialManagement600"|"materialManagement700"|"materialManagement800"|"materialManagement900"|"materialManagement950"|"materialManagementDefault"|"sand50"|"sand100"|"sand200"|"sand300"|"sand400"|"sand500"|"sand600"|"sand700"|"sand800"|"sand900"|"sand950"|"sandDefault";
export const colors: Record<ColorName, string> = {
  algae50: "#f2f7f5",
  algae100: "#dfece6",
  algae200: "#cfe2da",
  algae300: "#97beb1",
  algae400: "#6a9d8c",
  algae500: "#498070",
  algae600: "#366558",
  algae700: "#2b5147",
  algae800: "#24413a",
  algae900: "#1e3631",
  algae950: "#101e1c",
  algaeDefault: "#cfe2da",
  blue50: "#f0f8fe",
  blue100: "#deeefb",
  blue200: "#c4e3f9",
  blue300: "#9cd1f4",
  blue400: "#6db8ed",
  blue500: "#4b9ce6",
  blue600: "#3580db",
  blue700: "#2c6ac6",
  blue800: "#2a57a3",
  blue900: "#274b81",
  blue950: "#1c2f4f",
  blueDefault: "#2c6ac6",
  foam50: "#ffffff",
  foam100: "#efefef",
  foam200: "#dcdcdc",
  foam300: "#bdbdbd",
  foam400: "#989898",
  foam500: "#7c7c7c",
  foam600: "#656565",
  foam700: "#525252",
  foam800: "#464646",
  foam900: "#3d3d3d",
  foam950: "#292929",
  foamDefault: "#ffffff",
  greyDefault: "#7c7c7c",
  freshWater50: "#f1f6fd",
  freshWater100: "#e0eaf9",
  freshWater200: "#cadcf6",
  freshWater300: "#a1c3ef",
  freshWater400: "#75a3e5",
  freshWater500: "#5483dd",
  freshWater600: "#4068d0",
  freshWater700: "#3655bf",
  freshWater800: "#31469c",
  freshWater900: "#2c3e7c",
  freshWater950: "#1f274c",
  freshWaterDefault: "#cadcf6",
  green50: "#f4fbea",
  green100: "#e7f5d2",
  green200: "#ceecaa",
  green300: "#afde78",
  green400: "#88c941",
  green500: "#72b230",
  green600: "#568e22",
  green700: "#436c1f",
  green800: "#38571d",
  green900: "#314a1d",
  green950: "#17280b",
  greenDefault: "#88c941",
  lagoon50: "#f2fbf9",
  lagoon100: "#d3f4ee",
  lagoon200: "#a6e9de",
  lagoon300: "#72d6c9",
  lagoon400: "#4ebfb4",
  lagoon500: "#2ca096",
  lagoon600: "#21807b",
  lagoon700: "#1e6763",
  lagoon800: "#1c5351",
  lagoon900: "#1c4544",
  lagoon950: "#0a2929",
  lagoonDefault: "#4ebfb4",
  ocean50: "#f3f4ff",
  ocean100: "#e9eafe",
  ocean200: "#d6d9fe",
  ocean300: "#b5b8fd",
  ocean400: "#8b8bfa",
  ocean500: "#645df5",
  ocean600: "#4f3bec",
  ocean700: "#4029d8",
  ocean800: "#3522b5",
  ocean900: "#2e1e94",
  ocean950: "#150e56",
  oceanDefault: "#150e56",
  orange50: "#fef8ec",
  orange100: "#fbebca",
  orange200: "#f8d68f",
  orange300: "#f4bc55",
  orange400: "#f2a93c",
  orange500: "#ea8116",
  orange600: "#cf5f10",
  orange700: "#ac4111",
  orange800: "#8c3214",
  orange900: "#732a14",
  orange950: "#421406",
  orangeDefault: "#f2a93c",
  red50: "#fef2f2",
  red100: "#fee2e2",
  red200: "#fecaca",
  red300: "#fba6a6",
  red400: "#f77272",
  red500: "#ee4545",
  red600: "#dd3434",
  red700: "#b81d1d",
  red800: "#981c1c",
  red900: "#7e1e1e",
  red950: "#450a0a",
  redDefault: "#dd3434",
  accounting50: "#f9f8f7",
  accounting100: "#f2efee",
  accounting200: "#e8e3e0",
  accounting300: "#d8cec9",
  accounting400: "#c0b1a9",
  accounting500: "#b2a299",
  accounting600: "#907d72",
  accounting700: "#78675d",
  accounting800: "#645750",
  accounting900: "#564c46",
  accounting950: "#2c2623",
  accountingDefault: "#b2a299",
  analysis50: "#fffbeb",
  analysis100: "#ffedaf",
  analysis200: "#ffe488",
  analysis300: "#ffd04a",
  analysis400: "#ffbb20",
  analysis500: "#f99907",
  analysis600: "#dd7202",
  analysis700: "#b74f06",
  analysis800: "#943c0c",
  analysis900: "#7a310d",
  analysis950: "#461802",
  analysisDefault: "#ffedaf",
  cashRegisterSheet50: "#fef4f2",
  cashRegisterSheet100: "#fee7e2",
  cashRegisterSheet200: "#fed3ca",
  cashRegisterSheet300: "#fcae9d",
  cashRegisterSheet400: "#f88971",
  cashRegisterSheet500: "#ef6344",
  cashRegisterSheet600: "#dc4726",
  cashRegisterSheet700: "#b9381c",
  cashRegisterSheet800: "#99321b",
  cashRegisterSheet900: "#7f2f1d",
  cashRegisterSheet950: "#45150a",
  cashRegisterSheetDefault: "#fcae9d",
  documents50: "#f2f8fd",
  documents100: "#e4f0fa",
  documents200: "#afd6f1",
  documents300: "#8dc7ec",
  documents400: "#51abdf",
  documents500: "#2a8fcd",
  documents600: "#1b72ae",
  documents700: "#175b8d",
  documents800: "#174e75",
  documents900: "#194261",
  documents950: "#102a41",
  documentsDefault: "#afd6f1",
  haccp50: "#f2f6fc",
  haccp100: "#e1ebf8",
  haccp200: "#cadbf3",
  haccp300: "#b1cced",
  haccp400: "#7ba6df",
  haccp500: "#5c87d5",
  haccp600: "#486dc8",
  haccp700: "#3e5bb7",
  haccp800: "#374c96",
  haccp900: "#314177",
  haccp950: "#222a49",
  haccpDefault: "#b1cced",
  hr50: "#f5faf3",
  hr100: "#e7f4e4",
  hr200: "#cfe8ca",
  hr300: "#b8dbb0",
  hr400: "#7db870",
  hr500: "#5a9b4c",
  hr600: "#477f3a",
  hr700: "#396530",
  hr800: "#30512a",
  hr900: "#294324",
  hr950: "#12240f",
  hrDefault: "#b8dbb0",
  importExport50: "#f6f5fd",
  importExport100: "#ededfa",
  importExport200: "#dfdef6",
  importExport300: "#bebaed",
  importExport400: "#a8a0e5",
  importExport500: "#8a79d9",
  importExport600: "#775ccb",
  importExport700: "#664ab7",
  importExport800: "#553d9a",
  importExport900: "#47347e",
  importExport950: "#2c2055",
  importExportDefault: "#bebaed",
  materialManagement50: "#fbf7fd",
  materialManagement100: "#f6edfa",
  materialManagement200: "#eedef6",
  materialManagement300: "#dbb8ea",
  materialManagement400: "#ce9fe1",
  materialManagement500: "#ba79d3",
  materialManagement600: "#a75bc2",
  materialManagement700: "#8f48a8",
  materialManagement800: "#783f8a",
  materialManagement900: "#62346f",
  materialManagement950: "#441c4f",
  materialManagementDefault: "#dbb8ea",
  sand50: "#fefbec",
  sand100: "#fcf1c9",
  sand200: "#fae496",
  sand300: "#f7cd52",
  sand400: "#f5b82a",
  sand500: "#ee9812",
  sand600: "#d3730c",
  sand700: "#af510e",
  sand800: "#8e3f12",
  sand900: "#753412",
  sand950: "#431a05",
  sandDefault: "#fae496",
}